import { render, staticRenderFns } from "./vipGroup.vue?vue&type=template&id=c49c7a3c&scoped=true"
import script from "./vipGroup.vue?vue&type=script&lang=js"
export * from "./vipGroup.vue?vue&type=script&lang=js"
import style0 from "./vipGroup.vue?vue&type=style&index=0&id=c49c7a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49c7a3c",
  null
  
)

export default component.exports